import { render, staticRenderFns } from "./DocumentsPage.vue?vue&type=template&id=6607df27"
import script from "./DocumentsPage.vue?vue&type=script&lang=ts"
export * from "./DocumentsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports